/**
 * Allow plugins to extend the Editor instance
 */
const withExtendEditor = (editor, plugins) => {
  return plugins.reduce((extendedEditor, plugin) => {
    if (plugin.extendEditor) {
      return plugin.extendEditor(extendedEditor);
    }
    return extendedEditor;
  }, editor);
};

export { withExtendEditor };
